module.exports = __webpack_public_path__ + "static/media/Marktheprop.298ae116.svg";